
<div class="vox-table connectivity-table">
  <table>
      <thead>
          <tr>
              <td translate class="sortable">
                  <!-- TODO: add this code when backend sorting is ready
                      (click)="toggleSort('mac_address')" -->
                  <div class="label-container">
                      <span translate>connectivity.table.id.label</span>
                      <!-- <i *ngIf="sort.mac_address" class="icon-small-arrow-dropdown"
                          [ngClass]="{'asc':sort.mac_address === 'asc' }"></i> -->
                  </div>
              </td>
              <td translate class="sortable">
                  <!-- TODO: add this code when backend sorting is ready
                      (click)="toggleSort('model')" -->
                  <div class="label-container">
                      <span translate>connectivity.table.brand.label</span>
                      <!-- <i *ngIf="sort.model" class="icon-small-arrow-dropdown"
                          [ngClass]="{'asc':sort.model === 'asc' }"></i> -->
                  </div>
              </td>
              <td translate class="sortable">
                  <!-- TODO: add this code when backend sorting is ready
                      (click)="toggleSort('status')" -->
                  <div class="label-container">
                      <span translate>connectivity.table.model.label</span>
                      <!-- <i *ngIf="sort.status" class="icon-small-arrow-dropdown"
                          [ngClass]="{'asc':sort.status === 'asc' }"></i> -->
                  </div>
              </td>
              <td translate class="sortable">
                  <!-- TODO: add this code when backend sorting is ready
                      (click)="toggleSort('alphaname')" -->
                  <div class="label-container">
                      <span translate>connectivity.table.type.label</span>
                      <!-- <i *ngIf="sort.alphaname" class="icon-small-arrow-dropdown"
                          [ngClass]="{'asc':sort.alphaname === 'asc' }"></i> -->
                  </div>
              </td>
              <td translate class="sortable">
                  <!-- TODO: add this code when backend sorting is ready
                      (click)="toggleSort('company_id')" -->
                  <div class="label-container">
                      <span translate>connectivity.table.documents.label</span>
                      <!-- <i *ngIf="sort.company_id" class="icon-small-arrow-dropdown"
                          [ngClass]="{'asc':sort.company_id === 'asc' }"></i> -->
                  </div>
              </td>
              <td translate class="sortable">
                  <!-- TODO: add this code when backend sorting is ready
                      (click)="toggleSort('pbx_id')" -->
                  <div class="label-container">
                      <span translate>connectivity.table.timestamp.label</span>
                      <!-- <i *ngIf="sort.pbx_id" class="icon-small-arrow-dropdown"
                          [ngClass]="{'asc':sort.pbx_id === 'asc' }"></i> -->
                  </div>
              </td>
              <td translate class="sortable">
                  <!-- TODO: add this code when backend sorting is ready
                      (click)="toggleSort('pbx_id')" -->
                  <div class="label-container">
                      <span translate>connectivity.table.actions.label</span>
                      <!-- <i *ngIf="sort.pbx_id" class="icon-small-arrow-dropdown"
                          [ngClass]="{'asc':sort.pbx_id === 'asc' }"></i> -->
                  </div>
              </td>
          </tr>
      </thead>
      <tbody *ngIf="!loadingTable">
          <tr *ngFor="let entry of catalogEntryList">
              <td>{{entry.id}}</td>
              <td>{{entry.brand}}</td>
              <td>{{entry.model}}</td>
              <td>
                <gdp-connectivity-entry-type [type]="entry.type"></gdp-connectivity-entry-type>
              </td>
              <td>
                <div class="links-container" *ngIf="entry?.links?.length > 0">
                    <a *ngFor="let link of entry.links" [href]="link.url" target="_blank">{{link.name}}</a>
                </div>
                <div class="links-container" *ngIf="entry?.links?.length === 0">
                    <span> - </span>
                </div>
              </td>
              <td>{{entry.created_at | date: 'dd.MM.yyyy'}} / {{entry.updated_at | date: 'dd.MM.yyyy'}}</td>
              <td>
                <div class="actions-container">
                    <button class="action btn-warning vox-btn" (click)="openEditDocumentsModal(entry)" [ngbTooltip]="'connectivity.table.actions.tooltips.manage-documents' | translate" container="body">
                        <i class="icon-small-template"></i>
                    </button>
                    <button class="action btn-warning vox-btn" (click)="openEditModal(entry)" [ngbTooltip]="'connectivity.table.actions.tooltips.edit' | translate" container="body">
                        <i class="icon-small-edit"></i>
                    </button>
                    <button class="action btn-danger vox-btn" (click)="openDeleteModal(entry)" [ngbTooltip]="'connectivity.table.actions.tooltips.delete' | translate" container="body">
                        <i class="icon-small-delete"></i>
                    </button>
                </div>
              </td>
          </tr>
      </tbody>
      <tbody *ngIf="loadingTable">
          <tr *ngFor="let i of loadingLines">
              <td colspan="7">
                  <ngx-skeleton-loader></ngx-skeleton-loader>
              </td>
          </tr>
      </tbody>
      <tbody *ngIf="!loadingTable && catalogEntryList?.length === 0">
          <tr>
              <td class="empty-table" colspan="7" translate>connectivity.table.empty</td>
          </tr>
      </tbody>
  </table>
</div>